/* eslint-disable react/forbid-prop-types */
/* eslint-disable no-undef */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/control-has-associated-label */
import React, { useEffect, useState } from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslation } from 'react-i18next';

const propTypes = {
  links: PropTypes.array,
  title: PropTypes.string,
  desc: PropTypes.string,
};
const defaultProps = {
  links: {},
  title: '',
  desc: '',
};

function Footer({
  title, links, desc,
}) {
  const { t } = useTranslation();
  const [year, setYear] = useState('');
  useEffect(() => {
    setYear(new Date().getFullYear());
  }, []);
  return (
    <div className="mt-1 pt-5 pb-5 bg-primary text-light no-list-style">
      <div className="container">
        <div className="row">
          <div className="col-lg-5 col-xs-12 pb-3">
            <h2>{title}</h2>
            <p className="pr-5 text-white-50 mb-0">{desc}</p>
            <p className="pb-0 mb-0 fw-bold mb-0">{t('footer.servingSince', { year: 2021 })}</p>
            <p className="mb-3 pt-0 mt-0">{t('footer.servingSince-2')}</p>
            <div className="social-links">
              <a href="https://www.instagram.com/cv_therapy/" alt="Instagram" target="_blank" rel="noreferrer noopener" className="text-facebook p-1"><FontAwesomeIcon icon={['fab', 'instagram']} className="large-icon" /></a>
              <a href="https://www.yelp.com/biz/cv-therapy-counseling-and-wellness-center-palm-desert-2?utm_campaign=www_business_share_popup&utm_medium=copy_link&utm_source=(direct)" alt="Yelp" target="_blank" rel="noreferrer noopener" className="text-facebook p-1"><FontAwesomeIcon icon={['fab', 'yelp']} className="large-icon" /></a>
            </div>
          </div>
          <div className="col-lg-3 col-xs-12 pb-3">
            <h4 className="mt-lg-0 mt-sm-4">{t('footer.links')}</h4>
            <ul className="m-0 p-0">
              {_.map(links, (link) => (
                <li key={link.text} className="mb-1">
                  <FontAwesomeIcon
                    icon={['fa', link.icon]}
                  />
                  <Link className="ml-2 text-white nounderline fs-5" to={link.href}>{(` ${t(`navbar.${link.text}`)}`)}</Link>
                </li>
              ))}
            </ul>
          </div>
          <div className="col-lg-4 col-xs-12 pb-3">
            <h4 className="mt-lg-0 mt-sm-4">{t('footer.locationTitle')}</h4>
            <a className="text-white underline" href="https://maps.app.goo.gl/ZSVDYv57Zy7Sf1rJ6" target="_blank" rel="noreferrer noopener">
              <p className="m-0">{t('footer.location')}</p>
              <p>{t('footer.location-2')}</p>
            </a>
            <h6 className="mt-lg-0 mt-sm-4">CV Therapy, Lic #28256</h6>
            <h6 className="mt-lg-0 mt-sm-4">
              <a className="text-white underline" href="https://www.privacypolicygenerator.info/live.php?token=GR6XHhLPAe7A8fogvoSvc2NRDlRLycwV" target="_blank" rel="noreferrer noopener">Privacy Policy</a>
            </h6>
            <h6 className="mt-lg-0 mt-sm-4">
              <a className="text-white underline" href="https://www.termsofservicegenerator.net/live.php?token=JLhaou9yUfkuZp2F35rhNKDppQ2SF6FI" target="_blank" rel="noreferrer noopener">Terms of Service</a>
            </h6>

          </div>
        </div>
        <div className="row mb-3 mt-5">
          <hr className="text-dark" />
          <div className="col">
            <p>
              <small className="text-white-50">
                ©
                {`${(year)} `}
                CV Therapy All Rights Reserved.
              </small>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

Footer.propTypes = propTypes;
Footer.defaultProps = defaultProps;

export default Footer;
